import {EXPENSE_LANDING_CONST} from "../actionConstants";
import {PATHS, APPLICATION_CONSTANTS, EXPENSE_CONSTANTS} from '../../AppConstants';
import {getccbAxiosConfig} from '../../apisSetup/ccbConfig';
import { saveServerLogs} from '../../UtilityComponents/Util';
import {EXPENSE_TYPE, submittedExpenseReqBody, expenseToSubmitReqBody} from "../../expense/config";

const ccbAxiosApiCaller = getccbAxiosConfig(true, {
	[APPLICATION_CONSTANTS.DEVICE_TYPE_KEY] : APPLICATION_CONSTANTS.DEVICE_TYPE,
}, false)
export const fetchExpenseSummary = () => async dispatch => {
	let error = false;
	try {
		dispatch(setApiLoading({expenseType : EXPENSE_TYPE.EXPENSE_SUMMARY}));
		const response = await ccbAxiosApiCaller.get(PATHS.EXPENSE_SUMMARY);
		const responseData = response && response.data;
		if(responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE){
			dispatch({
				type: EXPENSE_LANDING_CONST.EXPENSE_SUMMARY,
				payload: responseData
			})
			return;
		}
		error = true;
	}
	catch (e) {
		error = true;
		saveServerLogs(e.stack, 'error', PATHS.EXPENSE_SUMMARY);
	}
	finally{
		if(error){
			dispatch(setApiError({expenseType : EXPENSE_TYPE.EXPENSE_SUMMARY}));			
		}
	}
}


export const fetchExpenseData = () => async dispatch => {
	dispatch(fetchExpenseDetail(expenseToSubmitReqBody, EXPENSE_TYPE.EXPENSES_TO_SUBMIT, false, true, true));
	dispatch(fetchExpenseDetail(submittedExpenseReqBody, EXPENSE_TYPE.SUBMITTED_EXPENSES));
}

export const fetchExpenseDetail = (filterQuery, expenseType, isSort= false, shouldFilter= false, isFirstCall = false) => async dispatch => {
	let error = false;
	try {
		dispatch(setApiLoading({expenseType : expenseType}));
		const response = await ccbAxiosApiCaller.post(PATHS.EXPENSE_DATA, filterQuery);
		const responseData = response && response.data;
		if(responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE){
			dispatch({
				type: EXPENSE_LANDING_CONST.EXPENSE_DATA,
				payload: {responseData,filterQuery, expenseType, isSort, shouldFilter, isFirstCall}
			})
			return;
		}
		error = true;
	}
	catch (e) {
		error = true;
		saveServerLogs(e.stack, 'error', PATHS.EXPENSE_DATA);
	}
	finally{
		if(error){
			dispatch(setApiError({expenseType : expenseType}));
		}
	}
}

export const fetchApprovalData = (filterQuery, expenseType, isSort= false) => async dispatch => {
	let error = false;
	try {
		dispatch(setApiLoading({expenseType : EXPENSE_TYPE.EXPENSE_APPROVAl}));
		const response = await ccbAxiosApiCaller.post(PATHS.APPROVAL_EXPENSE_DATA, filterQuery);
		const responseData = response && response.data;
		if(responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE){
			dispatch({
				type: EXPENSE_LANDING_CONST.EXPENSE_DATA,
				payload: {responseData,filterQuery, expenseType: EXPENSE_TYPE.EXPENSE_APPROVAl, isSort}
			})
			return;
		}
		error = true;
	}
	catch (e) {
		error = true;
		saveServerLogs(e.stack, 'error', PATHS.APPROVAL_EXPENSE_DATA);
	}
	finally{
		if(error){
			dispatch(setApiError({expenseType : EXPENSE_TYPE.EXPENSE_APPROVAl}));
		}
	}
}

export const setApiError = (payloadData) =>({
    type: EXPENSE_LANDING_CONST.EXPENSE_ERROR,
    payload:  payloadData
})

export const setApiLoading = (payloadData) =>({
    type: EXPENSE_LANDING_CONST.EXPENSE_LOADING,
    payload:  payloadData
})

export const newExpenseFeatures = (feature, close) => ({
	type: EXPENSE_LANDING_CONST.FEATURE_DATA,
	payload: {feature : close ? 0 : feature}
})

export const toggleExpenseLandingModal = (modalStateData) => ({
	type: EXPENSE_LANDING_CONST.EXPENSE_MODAL,
	payload: {modalData: {modalStateData}}
})

export const deleteExpenseData = (expenseId, expenseIndex, filterQuery) => async dispatch => {
	let error = false;
    try{
		const resp = await ccbAxiosApiCaller.delete(`${PATHS.EXPENSE_API}/${expenseId}`);
		const { data } = resp || {};
		if (data && data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			dispatch(fetchExpenseDetail(filterQuery, EXPENSE_TYPE.EXPENSES_TO_SUBMIT, true, true));
			dispatch(fetchExpenseSummary());
			return;
		} 
		error = true;
    } catch(e) {
		error = true;
		saveServerLogs(e.stack, 'error', PATHS.EXPENSE_API);
	}
	finally{
		if(error){
			dispatch(setApiError({expenseType : EXPENSE_TYPE.EXPENSES_TO_SUBMIT}));
		}
	}
}

export const filterExpenses = (filterQuery, expenseType, isSort, defaultFilter) => dispatch => {
	dispatch(setExpenseFilter(defaultFilter))
	dispatch(fetchExpenseDetail(filterQuery, expenseType, isSort, false));
}

const setExpenseFilter= (defaultFilter) => ({
	type: EXPENSE_LANDING_CONST.EXPENSE_FILTER,
	payload: defaultFilter
})

export const clearPageData = () => ({
	type: EXPENSE_LANDING_CONST.CLEAR_STATE
})
